import { environment } from '../../environments/environment'

export const formatBytes = (bytes: number) => {
    const units = ["bytes", "kb", "mb", "gb", "tb"];
    let i = 0;
    while (bytes >= 1024 && i < units.length - 1) {
        bytes /= 1024;
        i++;
    }
    return `${bytes.toFixed(2)} ${units[i]}`;
}

export const getMigratedUrl = (url?: string): string | undefined => {
    if(!url) return undefined
    for(let [key, value] of Object.entries(environment.migratedServices)) {
        if(url.includes(key)) return url.replace(key, <string> value)
    }

    return url
}

export const isInOldDomain = (url?: string): boolean => {
    if(!url) return false
    return url.includes(environment.previousDomain)
}